import type { Bucket } from '../stores/JobApplicationStore/types';

export const STATUS_SHORTLIST = 7;
export const STATUS_INTERVIEW = 6;
export const STATUS_OFFER = 4;
export const STATUS_ACCEPT = 3;

export const getDashisedBucket = (bucket: Bucket) =>
  (bucket || '').replace(/_/g, '-').toLocaleLowerCase();
